document.addEventListener('DOMContentLoaded', function() {
  const triggers = document.querySelectorAll('[data-trigger-megamenu]');
  const toolbar = document.querySelector('.toolbar');
  // const toolbarHeight = $('.toolbar-section').outerHeight(true);
  const body = document.body;
  let activeTimeout;
  // let resetBodyTimeout;
  // 获取当前路径
  // let path = window.location.pathname;
  // function transparentHeader(){
  //   $('#SiteHeader').attr('data-transparent','true');
  //   $('.header-section').css({
  //     'width':'100%',
  //   });
  // }
  // function disTransparentHeader(top){
  //   $('#SiteHeader').attr('data-transparent','false');
  //   $('#SiteHeader').css({
  //     'position':'fixed',
  //     'top':top+'px',
  //   });
  // }
  function showMegaMenu(triggerValue) {
    clearTimeout(activeTimeout);
    // clearTimeout(resetBodyTimeout);
    // Hide all mega menus
    const allMegaMenus = document.querySelectorAll('.megamnu-main-wrapper');
    allMegaMenus.forEach(menu => menu.classList.remove('active'));
    
    // Show the target mega menu
    const targetMegaMenu = document.querySelector(`[data-megamenu-for="${triggerValue}"]`);
    if (targetMegaMenu) {
      // let scrollPosition = Math.abs(parseInt(document.body.style.top.split('px')[0] || $(window).scrollTop()));
      // if((path === '/' || path === '/index.html' || path === '/home') && scrollPosition == 0 ){
      //   if(toolbar){
      //     disTransparentHeader(toolbarHeight);
      //   }else{
      //     disTransparentHeader(0);
      //   }
      // }
      // if(scrollPosition == 0 && toolbar){
      //   targetMegaMenu.style.top = `${toolbarHeight + 55}px`;
      // }else{
      //   targetMegaMenu.style.top = '55px';
      // }
      targetMegaMenu.classList.add('active');
      const megaMenuProducts = targetMegaMenu.querySelectorAll('.mega-menu-products');
      megaMenuProducts.forEach(product => {
        if(product.querySelectorAll('.mega-menu-product-card img')[0]){
          let imgHeight = product.querySelectorAll('.mega-menu-product-card img')[0].scrollHeight;
          product.querySelectorAll('.mm-view-all')[0].style.height = `${imgHeight}px`
        }
      });
      let height = (targetMegaMenu.querySelector('.mega-menu-collections .active').scrollHeight+6)+'px';
      targetMegaMenu.querySelector('.mega-menu-sidebar-scrollbar').style.height = height;
    }
  }
  function hideMegaMenu() {
    activeTimeout = setTimeout(() => {
      const allMegaMenus = document.querySelectorAll('.megamnu-main-wrapper');
      allMegaMenus.forEach(menu => {
        menu.classList.remove('active');
      });
      // if(window.innerWidth >= 1100 && document.querySelectorAll('.megamnu-main-wrapper.active').length == 0){
      //   resetBody()
      // }
      // let scrollPosition = Math.abs(parseInt(document.body.style.top.split('px')[0] || $(window).scrollTop())) ;
      // if(path === '/' || path === '/index.html' || path === '/home'){
      //   if(scrollPosition == 0){
      //     if(document.querySelector('#SiteHeader').getAttribute('mouseenter') == 'true' || window.innerWidth < 1100){
      //       return
      //     }
      //     transparentHeader();
      //   }else{
      //     disTransparentHeader(0)
      //   }
      // }
    }, 200);
  }

  // Close mega menu function
  function closeMegaMenu() {
    const allMegaMenus = document.querySelectorAll('.megamnu-main-wrapper');
    allMegaMenus.forEach(menu => {
      menu.classList.remove('active');
    });
    // let scrollPosition = Math.abs(parseInt(document.body.style.top.split('px')[0] || $(window).scrollTop())) ;
    // if(path === '/' || path === '/index.html' || path === '/home'){
    //   if(scrollPosition == 0){
    //     if(document.querySelector('#SiteHeader').getAttribute('mouseenter') == 'true' || window.innerWidth < 1100){
    //         return
    //       }
    //     transparentHeader();
    //   }else{
    //     disTransparentHeader(0)
    //   }
    // }
    // if(window.innerWidth >= 1100 && document.querySelectorAll('.megamnu-main-wrapper.active').length == 0){
    //   setTimeout(() => {
    //       resetBody()
    //   }, 200);
    // }
  }
  // function resetBody() {
  //   const scrollY = Math.abs(parseInt(body.style.top.split('px')[0] || $(window).scrollTop()));
  //     body.classList.remove('no-scroll');
  //     // 恢复滚动位置
  //     body.style.removeProperty('top');
  //     window.scrollTo(0, scrollY);
  //     $('#SiteHeader').css({
  //       'padding-right':'0px'
  //     });
  // }
  // Add event listeners to close buttons
  const closeButtons = document.querySelectorAll('.megamenu-close');
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeMegaMenu();
    });
  });

  triggers.forEach(trigger => {
    const triggerValue = trigger.getAttribute('data-trigger-megamenu');
    
    // Click event
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      const targetMegaMenu = document.querySelector(`[data-megamenu-for="${triggerValue}"]`);
      
      if (targetMegaMenu && targetMegaMenu.classList.contains('active')) {
        hideMegaMenu();
      } else {
        showMegaMenu(triggerValue);
      }
    });

    // Hover events
    trigger.addEventListener('mouseenter', function() {
      showMegaMenu(triggerValue);
      if(window.innerWidth < 1100){
        return
      }
      // setTimeout(() => {
      //   const scrollY  = Math.abs(parseInt(document.body.style.top.split('px')[0] || $(window).scrollTop()));
      //   // 保存当前滚动位置
      //   body.style.top = `-${scrollY}px`;
      //   body.classList.add('no-scroll');
      //   if(path === '/' || path === '/index.html' || path === '/home'){
      //     $('#SiteHeader').css({
      //       'padding-right':'15px'
      //     })
      //   }
      // }, 200);
    });

    trigger.addEventListener('mouseleave', function() {
      hideMegaMenu();
    });
  });

  // Keep mega menu open when hovering over it
  const megaMenus = document.querySelectorAll('.megamnu-main-wrapper');
  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', function() {
      clearTimeout(activeTimeout);
    });

    menu.addEventListener('mouseleave', function() {
      hideMegaMenu();
    });
  });

  // Close mega menu when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-trigger-megamenu]') && !e.target.closest('.megamnu-main-wrapper')) {
      hideMegaMenu();
    }
  });

  // Internal mega menu functionality
  // const megaMenuCollections = document.querySelectorAll('.mega-menu-collections a');
  // const megaMenuProducts = document.querySelectorAll('.mega-menu-products');

  // function switchMegaMenu(targetIndex) {
  //   megaMenuCollections.forEach(link => link.classList.remove('active'));
  //   megaMenuProducts.forEach(product => product.classList.remove('active'));
    
  //   const targetCollection = document.querySelector(`.mega-menu-collections a[data-loop-index="${targetIndex}"]`);
  //   const targetProduct = document.querySelector(`.mega-menu-products[data-loop-index="${targetIndex}"]`);
    
  //   if (targetCollection) targetCollection.classList.add('active');
  //   if (targetProduct) targetProduct.classList.add('active');
  // }

  // megaMenuCollections.forEach(link => {
  //   link.addEventListener('click', function(e) {
  //     e.preventDefault();
  //     const loopIndex = this.getAttribute('data-loop-index');
  //     switchMegaMenu(loopIndex);
  //   });

  //   link.addEventListener('mouseenter', function() {
  //     const loopIndex = this.getAttribute('data-loop-index');
  //     switchMegaMenu(loopIndex);
  //   });
  // });

  document.querySelectorAll('.close-details').forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      this.closest('details').removeAttribute('open');
    });
  });
});